import { IAddress, IAddressInput, Maybe } from '../graphql/schema/p4types';

export const addressUtil = (address: Maybe<IAddressInput> | Maybe<IAddress>): string => {
  if (!address) {
    return '';
  }

  let addressInfo: Maybe<string> = address.line1;
  addressInfo += address.line2 ? `, ${address.line2}` : '';
  addressInfo += address.line3 ? `, ${address.line3}` : '';
  addressInfo += address.line4 ? `, ${address.line4}` : '';
  addressInfo += address.line5 ? `, ${address.line5}` : '';
  addressInfo += address.country ? `, ${address.country.description}` : '';
  addressInfo += address.postCode ? `, ${address.postCode}` : '';

  return addressInfo;
};
